import React, { useState, useEffect, useMemo } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import Swal from 'sweetalert2';
import { FaLayerGroup } from 'react-icons/fa';
import { v4 as uuidv4 } from 'uuid';


const BASE = 'https://evercorenutrition.com';

const Checkout = () => {


 const sendPurchaseEvent = async (amount) => {
    const eventId = uuidv4();

    if (window.fbq) {
      window.fbq(
        'track',
        'Purchase',
        {
          value: amount,
          currency: 'INR'
        },
        {
          eventID: eventId
        }
      );
    }

    try {
      await fetch('https://evercorenutrition.com/ev_admin/api/fb-event/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          event_id: eventId,
          value: amount
        })
      });
    } catch (err) {
      console.error('FB server event failed:', err);
    }
  };

  const [deliveryType, setDeliveryType] = useState('standard');
  const [selectedPayment, setSelectedPayment] = useState('');
  const [selectedUPI, setSelectedUPI] = useState('');
  const [addresses, setAddresses] = useState([]);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [cartData, setCartData] = useState(null);
  const [loadingAddresses, setLoadingAddresses] = useState(true);
  const [loadingCart, setLoadingCart] = useState(true);
  const [loadingShipping, setLoadingShipping] = useState(false);
  const [placingOrder, setPlacingOrder] = useState(false);
  const [orderError, setOrderError] = useState('');
  const [notes, setNotes] = useState('');

  // Address Modal State
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [editingAddress, setEditingAddress] = useState(null);
  const [addressForm, setAddressForm] = useState({
    receiver_name: '',
    receiver_mobile: '',
    street: '',
    city: '',
    state: '',
    zip_code: '',
    country: 'India',
    address_type: 'home',
    is_primary: false
  });
  const [savingAddress, setSavingAddress] = useState(false);
  const [addressError, setAddressError] = useState('');

  // Shipping from calculate API
  const [shippingCharge, setShippingCharge] = useState(0);
  const [deliveryTime, setDeliveryTime] = useState('');

  const [appliedCoupon, setAppliedCoupon] = useState(() => {
    try {
      const saved = sessionStorage.getItem('appliedCoupon');
      return saved ? JSON.parse(saved) : null;
    } catch { return null; }
  });

  const paymentMethods = [
    { id: 'COD', title: 'Cash On Delivery', desc: 'Pay securely in cash when your order is delivered.' },
    { id: 'Prepaid', title: 'Prepaid', desc: 'Pay online via PhonePe, cards, UPI or net banking.' },
  ];

useEffect(() => {
  window.scrollTo(0, 0);
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}, []);

  const getCustomerId = () => {
    try {
      const userData = localStorage.getItem('userData');
      if (userData) {
        const parsed = JSON.parse(userData);
        return String(parsed.id || parsed.customer_id || '');
      }
    } catch (e) {}
    return null;
  };

  const getAuthHeaders = (token) => ({
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  });

  // ========== SweetAlert Functions ==========
  const showSuccessAlert = (message) =>
    Swal.fire({
      icon: 'success',
      title: 'Success!',
      text: message,
      timer: 3000,
      showConfirmButton: false,
    });

  const showErrorAlert = (message) =>
    Swal.fire({
      icon: 'error',
      title: 'Error!',
      text: message,
      timer: 1500,
      showConfirmButton: false,
    });

  const showWarningAlert = (message) =>
    Swal.fire({
      icon: 'warning',
      title: message,
      timer: 4000,
      showConfirmButton: false,
    });

  const showConfirmDialog = async (title, text) => {
    const result = await Swal.fire({
      title,
      text,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#0d6efd',
      cancelButtonColor: '#dc3545',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    });
    return result.isConfirmed;
  };

  // Fetch addresses
  const fetchAddresses = async () => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) return;

      const response = await fetch('https://evercorenutrition.com/ev_admin/api/customer/addresses/', {
        method: 'GET',
        headers: getAuthHeaders(token)
      });

      if (response.ok) {
        const data = await response.json();

        let addressesList = [];
        if (Array.isArray(data)) {
          addressesList = data;
        } else if (data.addresses && Array.isArray(data.addresses)) {
          addressesList = data.addresses;
        } else if (data.data && Array.isArray(data.data)) {
          addressesList = data.data;
        }

        setAddresses(addressesList);
        const primary = addressesList.find(a => a.is_primary) || addressesList[0];
        if (primary) setSelectedAddressId(primary.id);
      }
    } catch (err) {
      console.error('Error fetching addresses:', err);
      showErrorAlert('Failed to load addresses');
    } finally {
      setLoadingAddresses(false);
    }
  };

  useEffect(() => {
    fetchAddresses();
  }, []);

  // Add/Edit Address Handlers
  const handleAddAddress = () => {
    setEditingAddress(null);
    setAddressForm({
      street: '',
      city: '',
      state: '',
      zip_code: '',
      country: 'India',
      address_type: 'home',
      is_primary: false
    });
    setAddressError('');
    setShowAddressModal(true);
  };

  // const handleEditAddress = (address) => {
  //   setEditingAddress(address);
  //   setAddressForm({
  //     street: address.street || address.line1 || '',
  //     city: address.city || '',
  //     state: address.state || '',
  //     zip_code: address.zip_code || address.zip || '',
  //     country: address.country || 'India',
  //     address_type: address.address_type || 'home',
  //     is_primary: address.is_primary || false
  //   });
  //   setAddressError('');
  //   setShowAddressModal(true);
  // };

  const handleEditAddress = (address) => {
  setEditingAddress(address);

  setAddressForm({
    receiver_name:
      address.receiver_name ||
      address.name ||
      address.receiverName ||
      '',

    receiver_mobile:
      address.receiver_mobile ||
      address.mobile ||
      address.phone ||
      '',

    street: address.street || address.line1 || '',
    city: address.city || '',
    state: address.state || '',
    zip_code: address.zip_code || address.zip || '',
    country: address.country || 'India',
    address_type: address.address_type || 'home',
    is_primary: address.is_primary || false
  });

  setAddressError('');
  setShowAddressModal(true);
};

  const handleAddressFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    setAddressForm(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSaveAddress = async () => {
    if (!addressForm.street.trim()) {
      showWarningAlert('Please enter complete address');
      return;
    }
    if (!addressForm.city.trim()) {
      showWarningAlert('Please enter city');
      return;
    }
    if (!addressForm.state.trim()) {
      showWarningAlert('Please enter state');
      return;
    }
    if (!addressForm.zip_code.trim() || !/^\d{6}$/.test(addressForm.zip_code)) {
      showWarningAlert('Please enter a valid 6-digit PIN code');
      return;
    }

    setSavingAddress(true);
    setAddressError('');

    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        showErrorAlert('Please login to save address');
        return;
      }

      const customerId = getCustomerId();
      if (!customerId) {
        showErrorAlert('Could not identify customer. Please login again.');
        return;
      }

      const url = editingAddress
        ? `https://evercorenutrition.com/ev_admin/api/customer/addresses/${editingAddress.id}/`
        : 'https://evercorenutrition.com/ev_admin/api/customer/addresses/';

      const method = editingAddress ? 'PUT' : 'POST';

      const payload = {
        customer_id: customerId,
        receiver_name: addressForm.receiver_name,
        receiver_mobile: addressForm.receiver_mobile,
        street: addressForm.street,
        city: addressForm.city,
        state: addressForm.state,
        zip_code: addressForm.zip_code,
        country: addressForm.country,
        address_type: addressForm.address_type,
        is_primary: addressForm.is_primary
      };

      const response = await fetch(url, {
        method,
        headers: getAuthHeaders(token),
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        await fetchAddresses();
        setShowAddressModal(false);
        showSuccessAlert(editingAddress ? 'Address updated successfully!' : 'Address added successfully!');
      } else {
        const errorData = await response.json().catch(() => ({}));
        const errorMsg = errorData.message || errorData.error || 'Failed to save address';
        setAddressError(errorMsg);
        showErrorAlert(errorMsg);
      }
    } catch (err) {
      console.error('Error saving address:', err);
      showErrorAlert('Network error. Please try again.');
    } finally {
      setSavingAddress(false);
    }
  };

  const handleDeleteAddress = async (addressId) => {
    const confirmed = await showConfirmDialog(
      'Delete Address',
      'Are you sure you want to delete this address?'
    );

    if (!confirmed) return;

    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(
        `https://evercorenutrition.com/ev_admin/api/customer/addresses/${addressId}/`,
        {
          method: 'DELETE',
          headers: getAuthHeaders(token)
        }
      );

      if (response.ok) {
        await fetchAddresses();
        showSuccessAlert('Address deleted successfully!');
      } else {
        showErrorAlert('Failed to delete address');
      }
    } catch (err) {
      console.error('Error deleting address:', err);
      showErrorAlert('Network error. Please try again.');
    }
  };

  // Fetch cart
  useEffect(() => {
    const fetchCart = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const customerId = getCustomerId();
        if (!token || !customerId) return;

        const response = await fetch(
          `https://evercorenutrition.com/ev_admin/api/cart/?customer_id=${customerId}`,
          { method: 'GET', headers: getAuthHeaders(token) }
        );

        if (response.ok) {
          const data = await response.json();
          if (data.success) {
            setCartData(data.cart);
          }
        }
      } catch (err) {
        console.error('Error fetching cart:', err);
        showErrorAlert('Failed to load cart');
      } finally {
        setLoadingCart(false);
      }
    };
    fetchCart();
  }, []);

  // Subtotal calculation
  const subtotal = useMemo(() => {
    if (!cartData || !cartData.items) return 0;
    return cartData.items.reduce(
      (sum, item) => sum + parseFloat(item.unit_price || item.price || 0) * item.quantity,
      0
    );
  }, [cartData]);

  // Discount calculation
  const discountAmount = useMemo(() => {
    if (!appliedCoupon) return 0;
    if (appliedCoupon.discount_type === 'percentage') {
      const percentageDiscount = (subtotal * appliedCoupon.discount_value) / 100;
      return appliedCoupon.max_discount_amount
        ? Math.min(percentageDiscount, appliedCoupon.max_discount_amount)
        : percentageDiscount;
    } else if (appliedCoupon.discount_type === 'amount') {
      return appliedCoupon.discount_value;
    }
    return 0;
  }, [appliedCoupon, subtotal]);

  // Total calculation
  const total = useMemo(() => {
    return subtotal - discountAmount + shippingCharge;
  }, [subtotal, discountAmount, shippingCharge]);

  // Shipping calculation
  useEffect(() => {
    if (!cartData || !cartData.items || cartData.items.length === 0) {
      setShippingCharge(0);
      setDeliveryTime('');
      return;
    }

    const cartTotal = cartData.items.reduce(
      (sum, item) => sum + parseFloat(item.unit_price || item.price) * item.quantity,
      0
    );

    if (cartTotal <= 0) {
      setShippingCharge(0);
      setDeliveryTime('');
      return;
    }

    const calculateShipping = async () => {
      setLoadingShipping(true);
      try {
        const token = localStorage.getItem('authToken');
        const response = await fetch('https://evercorenutrition.com/ev_admin/api/shipping/calculate/', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(token && { Authorization: `Bearer ${token}` }),
          },
          body: JSON.stringify({ subtotal: cartTotal }),
        });

        if (response.ok) {
          const data = await response.json();
          setShippingCharge(parseFloat(data.shipping_charge) || 0);
          if (data.delivery_time) setDeliveryTime(data.delivery_time);
        }
      } catch (err) {
        console.error('Error calculating shipping:', err);
        showErrorAlert('Failed to calculate shipping');
      } finally {
        setLoadingShipping(false);
      }
    };

    calculateShipping();
  }, [cartData]);

  // Helper functions
  const getItemImage = (item) => {
    if (item.item_type === 'combo' && item.combo_image) {
      return item.combo_image.startsWith('http')
        ? item.combo_image
        : `${BASE}${item.combo_image}`;
    }

    const possibleImages = [
      item.variant_image,
      item.product_image,
      item.image,
      item.product_data?.main_image,
      item.product_data?.variant?.main_image
    ];

    const imageUrl = possibleImages.find(img => img && typeof img === 'string');

    if (!imageUrl) return '/assets/images/Yeast_Protein.png';
    if (imageUrl.startsWith('http')) return imageUrl;
    return `${BASE}${imageUrl}`;
  };

  const getItemDisplayName = (item) => {
    if (item.item_type === 'combo') {
      return item.combo_name || 'Combo Offer';
    }

    const parts = [];
    if (item.product_name) parts.push(item.product_name);
    if (item.variant_flavour && item.variant_flavour !== 'Default') {
      parts.push(item.variant_flavour);
    }
    if (item.variant_weight_display) {
      parts.push(item.variant_weight_display);
    }
    return parts.join(' - ');
  };

  const isLoading = loadingCart || loadingAddresses || loadingShipping;

  // Generate unique order ID
  const generateOrderId = () => {
    const timestamp = Date.now().toString(36).toUpperCase();
    const random = Math.random().toString(36).substring(2, 8).toUpperCase();
    return `ORD-${timestamp}${random}`;
  };

  // Helper function to clear the cart after order
  const clearCartAfterOrder = async (token, customerId) => {
    try {
      const fetchResponse = await fetch(
        `https://evercorenutrition.com/ev_admin/api/cart/?customer_id=${customerId}`,
        { method: 'GET', headers: getAuthHeaders(token) }
      );

      if (fetchResponse.ok) {
        const data = await fetchResponse.json();

        if (data.success && data.cart?.items?.length > 0) {
          for (const item of data.cart.items) {
            await fetch(
              `https://evercorenutrition.com/ev_admin/api/cart/items/${item.id}/`,
              {
                method: 'PATCH',
                headers: getAuthHeaders(token),
                body: JSON.stringify({ quantity: 0 })
              }
            );
          }
        }
      }
    } catch (err) {
      console.error('Error clearing cart:', err);
    }

    setCartData(prevCart => prevCart ? { ...prevCart, items: [] } : { items: [] });
    sessionStorage.removeItem('cartData');
    localStorage.removeItem('cartData');
    sessionStorage.removeItem('appliedCoupon');
    window.dispatchEvent(new Event('cartUpdated'));
  };

  // Handle Place Order - UPDATED with promo_code
  const handlePlaceOrder = async () => {
    setOrderError('');

    if (!selectedAddressId) {
      showWarningAlert('Please select a delivery address.');
      return;
    }
    if (!selectedPayment) {
      showWarningAlert('Please select a payment method.');
      return;
    }

    const token = localStorage.getItem('authToken');
    const customerId = getCustomerId();

    if (!token || !customerId) {
      showErrorAlert('Please login to place an order.');
      return;
    }

    const selectedAddress = addresses.find(a => a.id === selectedAddressId);
    if (!selectedAddress) {
      showErrorAlert('Selected address not found.');
      return;
    }

    if (!cartData || !cartData.items || cartData.items.length === 0) {
      showErrorAlert('Your cart is empty.');
      return;
    }

    // Format all prices to 2 decimals
    const formatPrice = (value) => parseFloat(parseFloat(value || 0).toFixed(2));
    
    const finalSubtotal = formatPrice(subtotal);
    const finalDiscount = formatPrice(discountAmount);
    const finalShipping = formatPrice(shippingCharge);
    const finalTotal = formatPrice(total);

    const processedItems = cartData.items.map(item => {
      const itemPrice = formatPrice(parseFloat(item.unit_price || item.price));
      const itemQuantity = parseInt(item.quantity);

      // Base structure
      const formattedItem = {
        quantity: itemQuantity,
        price: itemPrice,
        item_type: item.item_type || 'product'
      };

      // CRITICAL: Different structure for combo vs product
      if (item.item_type === 'combo') {
        formattedItem.combo_id = parseInt(item.combo_id);
        // DO NOT include product_id or variant_id for combo
      } else {
        formattedItem.product_id = parseInt(item.product_id);
        if (item.variant_id) {
          formattedItem.variant_id = parseInt(item.variant_id);
        }
      }

      return formattedItem;
    });

    const confirmed = await showConfirmDialog(
      'Confirm Order',
      `Total Amount: ₹${Math.round(finalTotal).toLocaleString('en-IN')}\n\nDo you want to place this order?`
    );

    if (!confirmed) return;

    setPlacingOrder(true);

    try {
      const orderId = generateOrderId();

      const shippingAddress = `${selectedAddress.street || selectedAddress.line1}, ${selectedAddress.city}, ${selectedAddress.state}, ${selectedAddress.zip_code || selectedAddress.zip}`;

  const payload = {
    customer: parseInt(customerId),
    order_id: orderId,

    payment_type: selectedPayment,

    // ✅ Selected Address ID
    address_id: selectedAddress.id,

    // ✅ Receiver details from selected address
    receiver_name: selectedAddress.receiver_name || '',
    receiver_mobile: selectedAddress.receiver_mobile || '',

    // ✅ Full address
    pickup_address: shippingAddress,

    // ✅ Optional notes
    additional_notes: notes || '',

    subtotal: finalSubtotal,
    shipping_charge: finalShipping,
    discount_amount: finalDiscount,
    total_amount: finalTotal,

    items: processedItems
  };

      // Only add optional fields if they have values
   if (notes) {
  payload.additional_notes = notes;
}
      // ✅ PROMO CODE ADDED HERE
      if (appliedCoupon) {
        payload.promo_code = appliedCoupon.code;
        // console.log('✅ Promo code applied:', appliedCoupon.code);
        // console.log('✅ Discount amount:', finalDiscount);
      } else {
        console.log('❌ No promo code applied');
      }

      console.log('=== FINAL REQUEST PAYLOAD ===', JSON.stringify(payload, null, 2));

      const response = await fetch('https://evercorenutrition.com/ev_admin/api/orders/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();
      // console.log('=== ORDER RESPONSE ===', data);

      if (response.ok && data.success) {
        
        if (selectedPayment === 'COD') {
           await sendPurchaseEvent(finalTotal); 
          await clearCartAfterOrder(token, customerId);
          sessionStorage.removeItem('appliedCoupon');

          const orderIdFromResponse = data.order?.order_id || data.order_id || data.id || orderId;
          
          showSuccessAlert('Order placed successfully!');
          setTimeout(() => {
            window.location.href = `/placeorder/${orderIdFromResponse}`;
          }, 1500);
        } 
        else if (selectedPayment === 'Prepaid') {
          // Get payment URL from response
          const paymentUrl = data.payment_url || data.checkout_url || data.redirect_url;
          
          // console.log('=== PAYMENT REDIRECT ===');
          // console.log('Payment URL:', paymentUrl);

          // Get order ID for redirect
const orderIdFromResponse = data.order?.order_id || data.order_id || data.id || orderId;

          
          if (paymentUrl && paymentUrl.startsWith('https')) {
            // Clear cart first
            await sendPurchaseEvent(finalTotal);
            await clearCartAfterOrder(token, customerId);
            sessionStorage.removeItem('appliedCoupon');
            
            // Store order details
            const orderDetails = {
              orderId: data.order_id || data.transaction_id || orderId,
              totalAmount: finalTotal,
              transactionId: data.transaction_id,
              timestamp: Date.now()
            };
            sessionStorage.setItem('pendingOrderDetails', JSON.stringify(orderDetails));
            
            // Show success message
            await Swal.fire({
              icon: 'success',
              title: 'Order Placed Successfully!',
              html: `
                <div style="text-align: center;">
                  <p><strong>Order ID:</strong> ${data.order_id || orderId}</p>
                  <p><strong>Amount:</strong> ₹${Math.round(finalTotal).toLocaleString('en-IN')}</p>
                  <p class="text-muted mt-3">Opening payment page in new tab...</p>
                </div>
              `,
              timer: 2000,
              showConfirmButton: false,
              allowOutsideClick: false
            });
            
            // CRITICAL: Open in NEW TAB instead of same tab
            window.open(paymentUrl, '_blank', 'noopener,noreferrer');

           setTimeout(() => {
      window.location.href = `/payment-success?transaction_id=${data.transaction_id}`;
    }, 500);
          

          } else {
            console.error('No payment URL found in response');
            showErrorAlert('Payment URL not received. Please try again.');
          }
        }
      } else {
        const errorMsg = data.message || data.error || 'Order failed';
        console.error('Order creation failed:', errorMsg, data);
        
        await Swal.fire({
          icon: 'error',
          title: 'Order Failed',
          text: errorMsg,
          confirmButtonText: 'OK',
          confirmButtonColor: '#dc3545'
        });
      }
    } catch (err) {
      console.error('Error placing order:', err);
      showErrorAlert('Network error. Please try again.');
    } finally {
      setPlacingOrder(false);
    }
  };

  return (
    <>
      <Navbar />

      {/* Address Popup Modal */}
      {showAddressModal && (
        <div className="custom-modal-overlay" onClick={() => setShowAddressModal(false)}>
          <div className="custom-modal" onClick={(e) => e.stopPropagation()}>
            <div className="custom-modal-header">
              <h5 style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <span style={{ backgroundColor: '#f4f4f4', padding: '10px', borderRadius: '12px', display: 'inline-flex' }}>
                  <i className="fa-solid fa-map-marker-alt" style={{ color: '#555' }}></i>
                </span>
                {editingAddress ? 'Edit Address' : 'Add New Address'}
              </h5>
              <button className="modal-close-btn" onClick={() => setShowAddressModal(false)}>
                <i className="fa-solid fa-times"></i>
              </button>
            </div>

            <div className="custom-modal-body">
              <div className="row g-4">
                <div className="col-12">
                  <label className="modern-form-label">Address Label</label>
                  <select
                    name="address_type"
                    value={addressForm.address_type}
                    onChange={handleAddressFormChange}
                    className="modern-form-control modern-select"
                  >
                    <option value="home">Home</option>
                    <option value="office">Office</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="col-md-6">
  <label className="modern-form-label">Receiver Name *</label>
  <input
    type="text"
    name="receiver_name"
    value={addressForm.receiver_name}
    onChange={handleAddressFormChange}
    placeholder="Full Name"
    className="modern-form-control"
  />
</div>

<div className="col-md-6">
  <label className="modern-form-label">Mobile Number *</label>
  <input
    type="text"
    name="receiver_mobile"
    value={addressForm.receiver_mobile}
    onChange={handleAddressFormChange}
    placeholder="10-digit mobile"
    maxLength="10"
    className="modern-form-control"
    onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, ''); }}
  />
</div>

                <div className="col-12">
                  <label className="modern-form-label">Complete Address *</label>
                  <textarea
                    name="street"
                    value={addressForm.street}
                    onChange={handleAddressFormChange}
                    placeholder="House no., building, street, area"
                    rows="2"
                    className="modern-form-control"
                  />
                </div>

                <div className="col-md-6">
                  <label className="modern-form-label">City *</label>
                  <input
                    type="text"
                    name="city"
                    value={addressForm.city}
                    onChange={handleAddressFormChange}
                    placeholder="City"
                    className="modern-form-control"
                  />
                </div>

                <div className="col-md-6">
                  <label className="modern-form-label">State *</label>
                  <input
                    type="text"
                    name="state"
                    value={addressForm.state}
                    onChange={handleAddressFormChange}
                    placeholder="State"
                    className="modern-form-control"
                  />
                </div>

                <div className="col-md-6">
                  <label className="modern-form-label">PIN Code *</label>
                  <input
                    type="text"
                    name="zip_code"
                    value={addressForm.zip_code}
                    onChange={handleAddressFormChange}
                    placeholder="6-digit PIN code"
                    maxLength="6"
                    className="modern-form-control"
                    onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, ''); }}
                  />
                </div>

                <div className="col-md-6">
                  <label className="modern-form-label">Country</label>
                  <input
                    type="text"
                    name="country"
                    value={addressForm.country}
                    onChange={handleAddressFormChange}
                    className="modern-form-control"
                    readOnly
                  />
                </div>

                {addressError && (
                  <div className="col-12">
                    <div className="alert alert-danger py-2">{addressError}</div>
                  </div>
                )}
              </div>
            </div>

            <div className="custom-modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setShowAddressModal(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSaveAddress}
                disabled={savingAddress}
              >
                {savingAddress ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                    Saving...
                  </>
                ) : (
                  'Save Address'
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Breadcrumb */}
      <section className="breadcrumb-section pt-0">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb-contain">
                <h2>Checkout</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item"><a href="/"><i className="fa-solid fa-house"></i></a></li>
                    <li className="breadcrumb-item active">Checkout</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Checkout Section */}
      <section className="checkout-section-2 section-b-space">
        <div className="container-fluid-lg">
          <div className="row g-sm-4 g-3">
            {/* LEFT SIDE */}
            <div className="col-lg-8">
              <div className="left-sidebar-checkout">
                <div className="checkout-detail-box">
                  <ul>
                    {/* DELIVERY ADDRESS */}
                    <li>
                      <div className="checkout-icon">
                        <lord-icon target=".nav-item" src="https://cdn.lordicon.com/ggihhudh.json" trigger="loop-on-hover" colors="primary:#0d6efd,secondary:#0d6efd,tertiary:#0d6efd" className="lord-icon"></lord-icon>
                      </div>
                      <div className="checkout-box">
                        <div className="checkout-title">
                          <h4>Delivery Address</h4>
                          <button className="add-address-btn" onClick={handleAddAddress}>
                            <i className="fa-solid fa-plus"></i> Add New
                          </button>
                        </div>

                        <div className="checkout-detail">
                          {loadingAddresses ? (
                            <div className="text-center py-4">
                              <div className="spinner-border spinner-border-sm text-primary" role="status"></div>
                              <span className="ms-2 text-muted">Loading addresses...</span>
                            </div>
                          ) : addresses.length === 0 ? (
                            <div className="text-center py-4">
                              <p className="text-muted mb-3">No saved addresses found.</p>
                              <button className="btn btn-dark btn-sm" onClick={handleAddAddress}>
                                Add New Address
                              </button>
                            </div>
                          ) : (
                            <div className="addresses-grid">
                              {addresses.map((addr) => (
                                <div
                                  key={addr.id}
                                  className={`address-card ${selectedAddressId === addr.id ? 'selected' : ''}`}
                                  onClick={() => setSelectedAddressId(addr.id)}
                                >
                                  <div className="address-radio">
                                    <input
                                      type="radio"
                                      name="address"
                                      checked={selectedAddressId === addr.id}
                                      onChange={() => setSelectedAddressId(addr.id)}
                                    />
                                  </div>
                                  <div className="address-content">
                                    <div className="address-header">
                                      <span className="address-label">{addr.address_type || 'Address'}</span>
                                      {addr.is_primary && <span className="default-badge">Default</span>}
                                    </div>
                                    <div className="address-details">
                                    <p><strong>Name:</strong> {addr.receiver_name || '-'}</p>
                                    <p><strong>Mobile:</strong> {addr.receiver_mobile || '-'}</p>
                                      <p><strong>Address:</strong> {addr.street || addr.line1}</p>
                                      <p><strong>City:</strong> {addr.city}</p>
                                      <p><strong>State:</strong> {addr.state}</p>
                                      <p><strong>PIN:</strong> {addr.zip_code || addr.zip}</p>
                                      <p><strong>Country:</strong> {addr.country || 'India'}</p>
                                    </div>
                                    <div className="address-actions">
                                      <button
                                        className="edit-address-btn"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleEditAddress(addr);
                                        }}
                                      >
                                        <i className="fa-solid fa-pencil"></i> Edit
                                      </button>
                                      <button
                                        className="delete-address-btn"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleDeleteAddress(addr.id);
                                        }}
                                      >
                                        <i className="fa-solid fa-trash"></i> Delete
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </li>

                    {/* PAYMENT METHODS */}
                    <li>
                      <div className="checkout-icon">
                        <lord-icon target=".nav-item" src="https://cdn.lordicon.com/qmcsqnle.json" trigger="loop-on-hover" colors="primary:#0d6efd,secondary:#0d6efd,tertiary:#0d6efd" className="lord-icon"></lord-icon>
                      </div>
                      <div className="checkout-box">
                        <div className="checkout-title">
                          <h4>Payment Option</h4>
                        </div>
                        <div className="checkout-detail">
                          {paymentMethods.map((method) => (
                            <div
                              key={method.id}
                              className={`payment-card ${selectedPayment === method.id ? 'active' : ''}`}
                              onClick={() => setSelectedPayment(method.id)}
                            >
                              <label className="payment-option">
                                <input
                                  type="radio"
                                  name="payment"
                                  value={method.id}
                                  checked={selectedPayment === method.id}
                                  onChange={() => setSelectedPayment(method.id)}
                                />
                                <div className="payment-content">
                                  <div className="payment-title">
                                    {method.title}
                                  </div>
                                  <p className="payment-desc">{method.desc}</p>
                                </div>
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    </li>

                    {/* DELIVERY NOTES */}
                    <li>
                      <div className="checkout-icon">
                        <lord-icon target=".nav-item" src="https://cdn.lordicon.com/wmlleaaf.json" trigger="loop-on-hover" colors="primary:#0d6efd,secondary:#0d6efd,tertiary:#0d6efd" className="lord-icon"></lord-icon>
                      </div>
                      <div className="checkout-box">
                        <div className="checkout-title">
                          <h4>Delivery Notes (Optional)</h4>
                        </div>
                        <div className="checkout-detail">
                          <textarea
                            className="form-control"
                            rows="2"
                            placeholder="Add any special instructions for delivery"
                            value={notes}
                            onChange={(e) => setNotes(e.target.value)}
                          ></textarea>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* RIGHT SIDE - ORDER SUMMARY */}
            <div className="col-lg-4">
              <div className="right-side-summery-box">
                <div className="summery-box-2">
                  <div className="summery-header">
                    <h3>Order Summary</h3>
                    {deliveryTime && (
                      <span className="delivery-badge">
                        Delivery: {deliveryTime}
                      </span>
                    )}
                  </div>

                  <ul className="summery-contain">
                    {loadingCart ? (
                      <li className="text-center py-3">
                        <div className="spinner-border spinner-border-sm text-primary" role="status"></div>
                      </li>
                    ) : cartData && cartData.items && cartData.items.length > 0 ? (
                      cartData.items.map((item) => {
                        const displayName = getItemDisplayName(item);
                        const isCombo = item.item_type === 'combo';

                        return (
                          <li key={item.id} className={isCombo ? 'combo-item-row' : ''}>
  <img
    src={getItemImage(item)}
    className="checkout-image"
    alt={displayName}
  />

  <div className="item-details">
    <h4>
      {displayName}

      {isCombo && (
        <span className="combo-badge ms-2">
          <FaLayerGroup size={12} /> COMBO
        </span>
      )}
    </h4>

    <span className="item-quantity">x {item.quantity}</span>
  </div>

  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      minWidth: '90px'
    }}
  >
    {(() => {

      let mrp = 0;

      // Combo MRP
      if (item.item_type === 'combo') {
        mrp =
          item.combo_items_list?.reduce(
            (sum, ci) =>
              sum +
              (parseFloat(ci.mrp || 0) *
                parseInt(ci.quantity || 1)),
            0
          ) || 0;

        mrp = mrp * item.quantity;
      }

      // Product MRP
      else {
        mrp =
          parseFloat(item.variant_mrp || 0) *
          item.quantity;
      }

      const salePrice =
        parseFloat(item.unit_price || item.price || 0) *
        item.quantity;

      return (
        <>
          {mrp > salePrice && (
            <span
              style={{
                textDecoration: 'line-through',
                color: '#999',
                fontSize: '12px',
                marginBottom: '2px'
              }}
            >
              ₹{Math.round(mrp).toLocaleString('en-IN')}
            </span>
          )}

          <span className="item-price">
            ₹{Math.round(salePrice).toLocaleString('en-IN')}
          </span>
        </>
      );

    })()}
  </div>
</li>
                        );
                      })
                    ) : (
                      <li className="text-center text-muted py-3">No items in cart</li>
                    )}
                  </ul>

                  <ul className="summery-total">
                    <li>
                      <span>Subtotal</span>
                      <span className="price">₹{Math.round(subtotal).toLocaleString('en-IN')}</span>
                    </li>
                    <li>
                      <span className="d-flex align-items-center gap-2">
                        Shipping
                        {loadingShipping && (
                          <div className="spinner-border spinner-border-sm text-muted"></div>
                        )}
                      </span>
                      <span className="price">
                        {loadingShipping ? 'Calculating...' : `₹${Math.round(shippingCharge).toLocaleString('en-IN')}`}
                      </span>
                    </li>
                    {appliedCoupon && (
                      <li>
                        <span>
                          Coupon ({appliedCoupon.code})
                          <span className="coupon-badge">
                            {appliedCoupon.discount_type === 'percentage'
                              ? `-${appliedCoupon.discount_value}%`
                              : `-₹${appliedCoupon.discount_value}`}
                          </span>
                        </span>
                        <span className="price text-success">-₹{Math.round(discountAmount).toLocaleString('en-IN')}</span>
                      </li>
                    )}
                    <li className="list-total">
                      <span>Total</span>
                      <span className="total-price">₹{Math.round(total).toLocaleString('en-IN')}</span>
                    </li>
                  </ul>
                </div>

                {orderError && (
                  <div className="alert alert-danger mt-3">{orderError}</div>
                )}

                <button
                  className="place-order-btn"
                  onClick={handlePlaceOrder}
                  disabled={placingOrder || isLoading}
                >
                  {placingOrder ? (
                    <><span className="spinner-border spinner-border-sm me-2"></span>Placing Order...</>
                  ) : isLoading ? (
                    <><span className="spinner-border spinner-border-sm me-2"></span>Loading...</>
                  ) : (
                    `Place Order • ₹${Math.round(total).toLocaleString('en-IN')}`
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      <style>{`
        /* Modal Styles */
        .custom-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          backdrop-filter: blur(5px);
        }

        .custom-modal {
          background-color: #fff;
          border-radius: 20px;
          width: 90%;
          max-width: 700px;
          max-height: 90vh;
          overflow: hidden;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
          position: relative;
          animation: modalFadeIn 0.3s ease;
        }

        @keyframes modalFadeIn {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }

        .custom-modal-header {
          padding: 25px 30px;
          border-bottom: 1px solid #eaeaea;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .custom-modal-header h5 {
          color: #000;
          font-size: 1.4rem;
          font-weight: 600;
          margin: 0;
        }

        .modal-close-btn {
          background: #f0f0f0;
          border: none;
          color: #444;
          width: 36px;
          height: 36px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .modal-close-btn:hover {
          background: #e0e0e0;
          color: #000;
        }

        .custom-modal-body {
          padding: 30px;
          max-height: calc(90vh - 180px);
          overflow-y: auto;
          background-color: #fafafa;
        }

        .custom-modal-footer {
          padding: 20px 30px;
          border-top: 1px solid #eaeaea;
          display: flex;
          justify-content: flex-end;
          gap: 15px;
          background-color: #fff;
        }

        .modern-form-control {
          width: 100%;
          padding: 14px 16px;
          border: 2px solid #e0e0e0;
          border-radius: 12px;
          font-size: 15px;
          transition: all 0.3s ease;
          background: white;
          box-sizing: border-box;
        }

        .modern-form-control:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
          outline: none;
        }

        .modern-form-label {
          font-weight: 600;
          color: #333;
          margin-bottom: 8px;
          font-size: 14px;
          display: block;
        }

        .modern-select {
          appearance: none;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: right 16px center;
          padding-right: 40px;
        }

        .btn-primary {
          background: #0d6efd;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: background 0.2s;
        }

        .btn-primary:hover:not(:disabled) { background: #0b5ed7; }
        .btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }

        .btn-secondary {
          background: #6c757d;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: background 0.2s;
        }

        .btn-secondary:hover { background: #5a6268; }

        .checkout-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
        }

        .checkout-title h4 {
          margin: 0;
          font-size: 18px;
          font-weight: 600;
          color: #333;
        }

        .add-address-btn {
          background: none;
          border: 1px solid #0d6efd;
          color: #0d6efd;
          padding: 6px 15px;
          border-radius: 20px;
          font-size: 13px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
          display: flex;
          align-items: center;
          gap: 5px;
        }

        .add-address-btn:hover { background: #0d6efd; color: white; }

        .addresses-grid {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        .address-card {
          border: 1px solid #ddd;
          border-radius: 10px;
          padding: 15px;
          display: flex;
          gap: 15px;
          cursor: pointer;
          transition: all 0.2s;
          background: white;
        }

        .address-card:hover {
          border-color: #0d6efd;
          box-shadow: 0 4px 12px rgba(13, 110, 253, 0.1);
        }

        .address-card.selected {
          border-color: #0d6efd;
          background: #f8f9ff;
        }

        .address-radio { padding-top: 2px; }

        .address-radio input[type="radio"] {
          width: 18px;
          height: 18px;
          cursor: pointer;
        }

        .address-content { flex: 1; }

        .address-header {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 8px;
        }

        .address-label {
          font-weight: 600;
          color: #333;
          text-transform: uppercase;
          font-size: 14px;
        }

        .default-badge {
          background: #28a745;
          color: white;
          padding: 2px 8px;
          border-radius: 12px;
          font-size: 11px;
          font-weight: 500;
        }

        .address-details p {
          margin: 4px 0;
          color: #555;
          font-size: 14px;
          line-height: 1.5;
        }

        .address-details p strong {
          color: #333;
          font-weight: 600;
        }

        .address-actions {
          display: flex;
          gap: 15px;
          margin-top: 8px;
        }

        .edit-address-btn {
          background: none;
          border: none;
          color: #0d6efd;
          font-size: 13px;
          padding: 5px 0;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 5px;
        }

        .edit-address-btn:hover { text-decoration: underline; }

        .delete-address-btn {
          background: none;
          border: none;
          color: #dc3545;
          font-size: 13px;
          padding: 5px 0;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 5px;
        }

        .delete-address-btn:hover { text-decoration: underline; }

        .payment-card {
          border: 1px solid #ddd;
          border-radius: 10px;
          padding: 15px;
          margin-bottom: 15px;
          cursor: pointer;
          transition: all 0.2s;
        }

        .payment-card:hover { border-color: #0d6efd; }
        .payment-card.active { border-color: #0d6efd; background: #f8f9ff; }

        .payment-option {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          cursor: pointer;
          width: 100%;
        }

        .payment-option input[type="radio"] {
          margin-top: 2px;
          width: 18px;
          height: 18px;
        }

        .payment-content { flex: 1; }

        .payment-title {
          font-weight: 600;
          color: #333;
          margin-bottom: 4px;
        }

        .payment-desc {
          margin: 0;
          color: #666;
          font-size: 13px;
        }

        .summery-contain {
          list-style: none;
          padding: 0;
          margin: 0 0 20px 0;
        }

        .summery-contain li {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          padding: 10px 0;
          border-bottom: 1px solid #eee;
        }

        .summery-contain li:last-child { border-bottom: none; }

        .checkout-image {
          width: 60px;
          height: 60px;
          object-fit: contain;
          border-radius: 8px;
          background: #f8f9fa;
          padding: 5px;
        }

        .item-details { flex: 1; }

        .item-details h4 {
          margin: 0 0 4px 0;
          font-size: 14px;
          font-weight: 600;
          color: #333;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 5px;
        }

        .combo-badge {
          background: #f0f0f0;
          color: #666;
          padding: 2px 6px;
          border-radius: 4px;
          font-size: 10px;
          font-weight: 500;
          display: inline-flex;
          align-items: center;
          gap: 3px;
        }

        .item-quantity {
          font-size: 12px;
          color: #888;
          display: inline-block;
          margin-top: 4px;
        }

        .item-price {
          font-weight: 600;
          color: #333;
          font-size: 14px;
          white-space: nowrap;
        }

        .summery-total {
          list-style: none;
          padding: 0;
          margin: 0;
          border-top: 1px solid #ddd;
          padding-top: 15px;
        }

        .summery-total li {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px 0;
          color: #555;
          font-size: 14px;
        }

        .summery-total li span.price {
          font-weight: 500;
          color: #333;
        }

        .summery-total li.list-total {
          border-top: 1px dashed #ddd;
          margin-top: 8px;
          padding-top: 15px;
          font-weight: 600;
        }

        .summery-total li.list-total span {
          font-size: 16px;
          color: #333;
        }

        .summery-total li.list-total .total-price {
          color: #0d6efd;
          font-size: 18px;
        }

        .coupon-badge {
          background: #28a745;
          color: white;
          padding: 2px 6px;
          border-radius: 4px;
          font-size: 10px;
          margin-left: 8px;
        }

        .delivery-badge {
          background: #e7f3ff;
          color: #0d6efd;
          padding: 5px 10px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 500;
        }

        .place-order-btn {
          width: 100%;
          padding: 14px;
          background: #0d6efd;
          color: white;
          border: none;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: background 0.2s;
          margin-top: 20px;
        }

        .place-order-btn:hover:not(:disabled) { background: #0b5ed7; }
        .place-order-btn:disabled { opacity: 0.6; cursor: not-allowed; }

        .text-muted {
          color: #6c757d !important;
          font-size: 12px;
          margin-top: 4px;
          display: block;
        }

        @media (max-width: 768px) {
          .custom-modal { width: 95%; margin: 10px; }
          .custom-modal-header { padding: 20px; }
          .custom-modal-body { padding: 20px; }
          .custom-modal-footer { padding: 15px 20px; }
          .address-card { flex-direction: column; }
          .address-radio { padding-top: 0; }
          .address-actions { flex-direction: column; gap: 5px; }
          .summery-contain li { flex-wrap: wrap; }
          .item-price { margin-left: 72px; }
          .swal2-popup.swal2-modal { width: 90% !important; margin: 16px !important; }
        }
          @media (max-width: 768px) {
  .custom-modal { width: 95%; margin: 10px; }
  .custom-modal-header { padding: 20px; }
  .custom-modal-body { padding: 20px; }
  .custom-modal-footer { padding: 15px 20px; }
  .address-radio { padding-top: 0; }
  .summery-contain li { flex-wrap: wrap; }
  .item-price { margin-left: 72px; }
  .swal2-popup.swal2-modal { width: 90% !important; margin: 16px !important; }

  /* Center the checkout content */
  .left-sidebar-checkout {
    display: flex;
    justify-content: center;
  }

  .checkout-detail-box {
    width: 100%;
    max-width: 420px;
  }

  .checkout-detail-box ul {
    padding: 0;
  }

  .checkout-box {
    width: 100%;
  }

  .addresses-grid {
    width: 100%;
    align-items: center;
  }

  .address-card {
    flex-direction: column;
    width: 100%;
  }

  .address-actions {
    flex-direction: row;
    gap: 10px;
  }

  .payment-card {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  .checkout-detail {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .checkout-title {
    width: 100%;
  }
}
      `}</style>
    </>
  );
};

export default Checkout;